module.exports = __webpack_public_path__ + "static/media/4m_website_logo_sup_hkgbc.d221e92c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4m_website_logo_sup_hkgbc.jpg
// module id = 66
// module chunks = 0